import * as types from '../const/action.types';

export function setCurrentWindow(title, prominent = true) {
    return (dispatch) => {
        dispatch(currentWindow(title, prominent));
    };
}

export function currentWindow(title, prominent = true, search = false, filter = false) {
    return {
        type: types.SET_WINDOW,
        title,
        prominent,
        search,
        filter,
    };
}

export function setPreviousWindow() {
    return {
        type: types.SET_PREVIOUS_WINDOWS,
    };
}

export function setProminentToolBar(value) {
    return {
        type: types.SET_PROMINENT_TOOLBAR,
        value,
    };
}

export function setTools(components) {
    return {
        type: types.SET_TOOLS,
        components,
    };
}

export function setSearch(search) {
    return {
        type: types.SET_SEARCH,
        search,
    };
}

export function searchArray(values) {
    return {
        type: types.SET_SEARCH_ARRAY,
        values,
    };
}

export function setFilter(window, filter) {
    return {
        type: types.SET_FILTER,
        window,
        filter,
    };
}

export function setHideAppBar(show) {
    return {
        type: types.SET_APP_BAR,
        show,
    };
}



// WEBPACK FOOTER //
// ./src/actions/process.home.actions.js